import { COMPANY_REGISTER } from "./types";

export const companyRegisterAction = (data, onSuccess, onError) => {
    return {
        type: COMPANY_REGISTER,
        data,
        onSuccess,
        onError,
    };
};

